export default "__VITE_ASSET__CREdjafq__"